import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

import { ModalName } from './constants';
import Modal from './Modal';

export type ModalContextType = {
  modalName?: string;
  setModalName: Dispatch<SetStateAction<ModalName | undefined>>;
};

export const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = (): ModalContextType | undefined => useContext(ModalContext);

interface Props {
  children: ReactNode;
}

export const ModalProvider = ({ children }: Props): JSX.Element => {
  const [modalName, setModalName] = useState<ModalName>();

  const handleUnsetModal = (): void => {
    setModalName(undefined);
  };

  const context = useMemo(() => ({ modalName, setModalName }), [modalName, setModalName]);

  return (
    <ModalContext.Provider value={context}>
      <Modal modalName={modalName} unsetModal={handleUnsetModal} />
      {children}
    </ModalContext.Provider>
  );
};
